import { render, staticRenderFns } from "./PagamentosAluno.vue?vue&type=template&id=42314994&"
import script from "./PagamentosAluno.vue?vue&type=script&lang=js&"
export * from "./PagamentosAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports